/* global trigger:false */

/**
 * Submit buttons with spinners
 */

(function() {
	let allSubmitButtons = document.querySelectorAll('.js-submit-button');

	const preloaderHTML = `
		<div class="button__preloader button__preloader--hidden js-button-preloader">
			<div class="circular-spinner">
				<div class="circular-spinner__item circular-spinner__item--i1"></div>
				<div class="circular-spinner__item circular-spinner__item--i2"></div>
				<div class="circular-spinner__item circular-spinner__item--i3"></div>
				<div class="circular-spinner__item circular-spinner__item--i4"></div>
				<div class="circular-spinner__item circular-spinner__item--i5"></div>
				<div class="circular-spinner__item circular-spinner__item--i6"></div>
				<div class="circular-spinner__item circular-spinner__item--i7"></div>
				<div class="circular-spinner__item circular-spinner__item--i8"></div>
				<div class="circular-spinner__item circular-spinner__item--i9"></div>
				<div class="circular-spinner__item circular-spinner__item--i10"></div>
				<div class="circular-spinner__item circular-spinner__item--i11"></div>
				<div class="circular-spinner__item circular-spinner__item--i12"></div>
			</div>
		</div>
	`;

	const progressTextHTML = `
		<span class="button__progress-text" aria-hidden="true" role="none" aria-live="off">
			<span class="js-button-loading-text">Loading</span>
		</span>
	`;

	const initButton = function(button) {
		button.firstElementChild.firstElementChild.insertAdjacentHTML('beforebegin', progressTextHTML);
		button.firstElementChild.firstElementChild.insertAdjacentHTML('beforebegin', preloaderHTML);
		button.setAttribute('data-active', 'false');

		// Localize loading text
		if (button.getAttribute('data-loading-label')) {
			let loadingText = button.querySelector('.js-button-loading-text');
			loadingText.innerHTML = button.getAttribute('data-loading-label');
		}
	};

	[].forEach.call(allSubmitButtons, function(submitButton) {
		initButton(submitButton);

		let preloaderTimeout;
		let resetTimeout;

		const handleReset = function() {
			this.setAttribute('data-active', 'false');

			const buttonPreloader = this.querySelector('.button__preloader');
			const buttonContent = this.querySelector('.button__content');
			const buttonLoadingText = this.querySelector('.button__progress-text');

			buttonPreloader.classList.add('button__preloader--hidden');
			buttonPreloader.classList.remove('button__preloader--left-aligned');
			buttonContent.classList.remove('button__content--hidden');
			buttonLoadingText.classList.remove('button__progress-text--visible');
			buttonLoadingText.setAttribute('aria-hidden', 'true');
			buttonLoadingText.setAttribute('role', 'none');
			buttonLoadingText.setAttribute('aria-live', 'off');

			if (resetTimeout) {
				clearTimeout(resetTimeout);
			}

			if (preloaderTimeout) {
				clearTimeout(preloaderTimeout);
			}
		}

		submitButton.addEventListener('progress', function() {
			this.setAttribute('data-active', 'true');

			const buttonPreloader = this.querySelector('.button__preloader');
			const buttonContent = this.querySelector('.button__content');
			const buttonLoadingText = this.querySelector('.button__progress-text');

			buttonPreloader.classList.remove('button__preloader--hidden');
			buttonContent.classList.add('button__content--hidden');
			buttonLoadingText.setAttribute('aria-hidden', 'false');
			buttonLoadingText.setAttribute('role', 'status');
			buttonLoadingText.setAttribute('aria-live', 'assertive');

			preloaderTimeout = setTimeout(function() {
				buttonPreloader.classList.add('button__preloader--left-aligned');
				buttonLoadingText.classList.add('button__progress-text--visible');
			}, 2000);

			// I'll set 50s timeout to be sure,
			// that button won't be blocked infinitely
			resetTimeout = setTimeout(handleReset.bind(this), 50000);
		});

		submitButton.addEventListener('active', handleReset);
	});
})();
